import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { SyncService } from '../../sync.service';
import { ListItem } from 'carbon-components-angular';
import { HttpService } from '../../http.service';

@Component({
	selector: 'edit-deal-modal',
	templateUrl: './edit-deal-modal.component.html',
	styleUrls: ['./edit-deal-modal.component.css'],
	encapsulation: ViewEncapsulation.None

})
export class EditDealModalComponent implements OnInit {

	userData = {};
	currentDeal = '';
	editDealModalOpen = false;

	dealName = '';
	dealNameInvalid = false;
	dealNameInvalidText = '';

	fundName = '';
	fundNameInvalid = false;
	fundNameInvalidText = '';

	fundTypes = [
		'PE Fund',
		'VC Fund',
		'Credit Fund',
		'Fund of Funds',
		'Hybrid Investment Fund',
	];
	fundType = '';
	fundInvalid = false;

	receivedDate: any = null;
	receivedDateObject: any = [new Date()];
	receivedDateInvalid = false;

	deadlineDate: any = null;
	deadlineDateObject: any = [new Date()];
	deadlineDateInvalid = false;

	pricingReferenceDate: any = null;
	pricingReferenceDateObject: any = [new Date()];
	pricingReferenceDateInvalid = false;

	deals: any = [];

	constructor(
		private cdr: ChangeDetectorRef,
		private renderer: Renderer2,
		public syncService: SyncService,
		public httpService: HttpService,
	) {}

	@ViewChild('cdsModalContent') cdsModalContent!: ElementRef;
	@ViewChild('datePicker1') datePicker1!: ElementRef;
	@ViewChild('datePicker2') datePicker2!: ElementRef;
	@ViewChild('datePicker3') datePicker3!: ElementRef;

	fileTypeItems = [
		{
			'content': 'Annual or Quarterly Report',
			'selected': false
		},
		{
			'content': 'Audit or Financial Statement',
			'selected': false
		},
		{
			'content': 'Capital Account Statement',
			'selected': false
		},
		{
			'content': 'Fund and Portfolio Assets Performance',
			'selected': false
		},
		{
			'content': 'Limited Partnership Agreement',
			'selected': false
		},
		{
			'content': 'Other',
			'selected': false
		}
	]

	setTargetMinWidth(): void {

		const modalWidth = this.cdsModalContent.nativeElement.offsetWidth;

		let datePickerInput = this.datePicker1.nativeElement.querySelector('.cds--date-picker__input');
		this.renderer.setStyle(datePickerInput, 'min-width', (modalWidth - 32).toString() + 'px');

		datePickerInput = this.datePicker2.nativeElement.querySelector('.cds--date-picker__input');
		this.renderer.setStyle(datePickerInput, 'min-width', (modalWidth - 32).toString() + 'px');

		datePickerInput = this.datePicker3.nativeElement.querySelector('.cds--date-picker__input');
		this.renderer.setStyle(datePickerInput, 'min-width', (modalWidth - 32).toString() + 'px');
	}

	ngOnInit() {

		this.syncService.userData$.subscribe((data) => {
			this.userData = data;
		});

		this.syncService.currentDeal$.subscribe((dealName: string) => {
			this.currentDeal = dealName;
			this.dealName = dealName;
			// @ts-ignore
			if (this.userData) {
				// @ts-ignore
				this.userData['Deals'].forEach((deal: any) => {
					if (deal['Deal Name'] === dealName) {
						this.fundName = deal['Fund Name'];
						this.fundType = deal['Fund Type'];
						this.receivedDate = deal['Received Date'];
						let [year, month, day] = this.receivedDate.split('-').map(Number);
						this.receivedDateObject = [new Date(year, month - 1, day)];
						this.deadlineDate = deal['Deadline Date'];
						[year, month, day] = this.deadlineDate.split('-').map(Number);
						this.deadlineDateObject = [new Date(year, month - 1, day)];
						this.pricingReferenceDate = deal['Pricing Reference Date'];
						[year, month, day] = this.pricingReferenceDate.split('-').map(Number);
						this.pricingReferenceDateObject = [new Date(year, month - 1, day)];
					}
				});
			}
		});

		this.syncService.editDealModalOpen$.subscribe((isOpen) => {
			this.editDealModalOpen = isOpen;
		});

		this.cdr.detectChanges();
		this.setTargetMinWidth();
		window.addEventListener('resize', this.setTargetMinWidth.bind(this));
	}

	closeModal() {
		this.syncService.updateDealEditModalOpen(false);
	}

	onSaveDealClick() {
		this.httpService.reloadUserData(false);
		// @ts-ignore
		this.userData['Deals'].forEach((deal: any) => {
			if (deal['Deal Name'] === this.currentDeal) {
				deal['Deal Name'] = this.dealName;
				deal['Fund Name'] = this.fundName;
				deal['Fund Type'] = this.fundType;
				deal['Received Date'] = this.receivedDate;
				deal['Deadline Date'] = this.deadlineDate;
				deal['Pricing Reference Date'] = this.pricingReferenceDate;
			}
		});
		this.syncService.updateUserData(this.userData); // EDIT DEAL DONE
		this.syncService.updateDealEditModalOpen(false);
	}

	onKeyUpDealName($event: any) {
		this.dealName = ($event.target as HTMLInputElement).value;
		this.validateDealName();
	}

	validateDealName() {
		this.dealNameInvalid = false;
		if (!this.dealName) {
			this.dealNameInvalid = true;
			this.dealNameInvalidText = 'Deal name cannot be empty.';
		}
		this.deals.forEach((deal: any) => {
			if (deal['Deal Name'] === this.dealName) {
				this.dealNameInvalid = true;
				this.dealNameInvalidText = 'Deal name already exists.';
			}
		});
	}

	validateFundName() {
		this.fundNameInvalid = false;
		if (!this.fundName) {
			this.fundNameInvalid = true;
			this.fundNameInvalidText = 'Fund name cannot be empty.';
		}
	}

	onKeyUpFundName($event: any) {
		this.fundName = ($event.target as HTMLInputElement).value;
		this.validateFundName();
	}

	validateFundType() {
		this.fundInvalid = !this.fundType;
	}

	onSelectFundType($event: any) {
		this.fundType = $event.target.value;
		this.validateFundType();
	}

	validateReceivedDate() {
		this.receivedDateInvalid = !this.receivedDate;
	}

	onSelectReceivedDate($event: any) {
		const date = new Date($event[0]);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		this.receivedDate = `${year}-${month}-${day}`;
		this.validateReceivedDate();
		console.log(this.receivedDate);
	}

	validateDeadlineDate() {
		this.deadlineDateInvalid = !this.deadlineDate;
	}

	onSelectDeadlineDate($event: any) {
		const date = new Date($event[0]);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		this.deadlineDate = `${year}-${month}-${day}`;
		this.validateDeadlineDate();
		console.log(this.deadlineDate);
	}

	validatePricingReferenceDate() {
		this.pricingReferenceDateInvalid = !this.pricingReferenceDate;
	}

	onSelectPricingReferenceDate($event: any) {
		const date = new Date($event[0]);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		this.pricingReferenceDate = `${year}-${month}-${day}`;
		this.validatePricingReferenceDate();
		console.log(this.pricingReferenceDate);
	}
}
